(() => {
  if (window.__hfSelectItemInstalled || window.Shopify?.designMode) return;
  window.__hfSelectItemInstalled = true;
  const lists = {
    pickup: 'PICK UP',
    set_bundle: 'SET & BUNDLE',
    representative_products: 'Representative Products',
    new_items: 'NEW ITEMS',
    gear_bestsellers: 'Gear Best Sellers',
    apparel_bestsellers: 'Apparel Best Sellers',
  };
  const seen = new WeakSet();
  let gesture = null;
  const cardFor = target => target instanceof Element ? target.closest('[data-hf-ga-card]') : null;
  document.addEventListener('pointerdown', event => {
    gesture = { id: event.pointerId, card: cardFor(event.target), x: event.clientX, y: event.clientY, moved: false };
  }, { passive: true, capture: true });
  document.addEventListener('pointermove', event => {
    if (gesture?.id === event.pointerId && Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 8) gesture.moved = true;
  }, { passive: true, capture: true });
  document.addEventListener('pointercancel', () => { if (gesture) gesture.moved = true; }, { passive: true });
  document.addEventListener('pointerup', event => {
    if (gesture?.id === event.pointerId && Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 8) gesture.moved = true;
  }, { passive: true, capture: true });
  document.addEventListener('dragstart', () => { if (gesture) gesture.moved = true; }, { passive: true, capture: true });
  document.addEventListener('scroll', event => {
    if (gesture?.card && event.target instanceof Element && event.target.contains(gesture.card)) gesture.moved = true;
  }, { passive: true, capture: true });

  function productPath(url) {
    const parsed = new URL(url, location.href);
    if (parsed.origin !== location.origin) return null;
    return decodeURIComponent(parsed.pathname).match(/\/products\/([^/]+)\/?$/)?.[1] || null;
  }

  function select(event) {
    try {
      if (seen.has(event) || event.defaultPrevented || (event.type === 'click' ? event.button !== 0 : event.button !== 1)) return;
      seen.add(event);
      const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
      const card = cardFor(link);
      const section = card?.closest('[data-hf-ga-list]');
      const listId = section?.dataset.hfGaList;
      if (!link || !card || !Object.hasOwn(lists, listId) || link.hasAttribute('download')) return;
      if (event.detail !== 0 && gesture?.card === card && gesture.moved) return;
      const analytics = window.Shopify?.analytics;
      if (typeof analytics?.publish !== 'function') return;
      const selected = card.querySelector('[data-hf-sibling-swatch]:checked');
      const product = JSON.parse((selected || card).dataset.hfGaProduct || 'null');
      const path = productPath(link.href);
      if (!product || !path || path !== productPath(product.url) || !/^\d+$/.test(product.id)) return;
      const variantId = new URL(link.href, location.href).searchParams.get('variant') || product.defaultVariant;
      const variant = product.variants.find(value => value.id === variantId && /^\d+$/.test(value.id));
      if (!variant || typeof product.name !== 'string' || !product.name) return;
      let index;
      if (listId === 'pickup') {
        const originals = [...section.querySelectorAll('[data-hf-marquee-original]')];
        index = originals.findIndex(value => value.dataset.marqueeCardId === card.dataset.marqueeCardId);
      } else {
        index = [...section.querySelectorAll('[data-hf-ga-card]')].indexOf(card);
      }
      if (index < 0) return;
      const item = {
        item_id: `shopify_ZZ_${product.id}_${variant.id}`,
        item_name: product.name,
        item_list_id: listId,
        item_list_name: lists[listId],
        index,
        quantity: 1,
        item_variant: variant.name,
      };
      if (typeof variant.price === 'number' && Number.isFinite(variant.price)) item.price = variant.price;
      const result = analytics.publish('hf_select_item', {
        item_list_id: listId,
        item_list_name: lists[listId],
        items: [item],
      });
      Promise.resolve(result).catch(() => {});
    } catch {}
  }
  document.addEventListener('click', select);
  document.addEventListener('auxclick', select);
})();
